/******************************** Import Package ************************************/
import React from "react";
import { Button as MuiButton } from "@mui/material";
import { styled } from "@mui/material/styles";

/******************************** Button Style ************************************/
const StyledButton = styled(MuiButton)(({ theme }) => ({
  margin: theme.spacing(0.5),
  textTransform: "none", // replaces "label" override
}));

/******************************** Button Component ************************************/
export default function Button(props) {
  const { text, size, color, variant, onClick, ...other } = props;

  return (
    <StyledButton
      variant={variant || "contained"}
      size={size || "large"}
      color={color || "primary"}
      onClick={onClick}
      {...other}
    >
      {text}
    </StyledButton>
  );
}
